import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import RegisterScreen from "./screens/RegisterScreen/RegisterScreen";
import UnAuthPinpoints from "./screens/UnAuthPinpoints/UnAuthPinpoints";
import HomeScreen from "./screens/HomeScreen/HomeScreen";
import PrivateRoute from "./utils/PrivateRoutes/PrivateRoutes";
import UnAuthProtected from "./utils/UnAuthProtected/UnAuthProtected";
import EmailVerification from "./screens/EmailVerification/EmailVerification";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/register",
    element: <RegisterScreen />,
  },
  {
    path: "/pinpoint",
    element: (
      <UnAuthProtected>
        <UnAuthPinpoints />,
      </UnAuthProtected>
    ),
  },
  {
    path: "/home",
    element: (
      <PrivateRoute>
        <HomeScreen />
      </PrivateRoute>
    ),
  },
  {
    path: "/reset-password/:uuid/:token",
    element: <EmailVerification />,
  },
]);

export default router;
